module.exports = __webpack_public_path__ + "static/media/advertise.530e904b.gif";